import React from 'react';
import { Grid, Typography, Divider, Box, useTheme } from '@mui/material';

import DefaultLogo from '@shared/assets/air/iconBlack.png';

import FlightsTooltipData from './FlightsTooltipData';

const TooltipData = ({ cell }) => {
  const theme = useTheme();
  const flights = cell?.data;

  if (!flights || !flights[0]?.origen) {
    return (
      <Typography
        component="span"
        sx={{
          fontFamily: 'Open Sans',
          fontSize: '18px',
          borderRadius: '8px',
          backgroundColor: '#FFFFFF',
          border: '1px solid #E5E5E5',
          padding: '0px 16px',
          display: 'flex',
          minHeight: '72px',
          maxWidth: '280px',
          placeItems: 'center',
          [theme.breakpoints.down('sm')]: {
            maxWidth: '150px',
            fontSize: '12px',
          },
        }}
      >
        No se encuentran vuelos disponibles ese día.
      </Typography>
    );
  }

  return (
    <Grid
      id="three-days-tooltip"
      container
      spacing={0}
      sx={{
        borderRadius: '8px',
        backgroundColor: '#FFFFFF',
        padding: '0px',
      }}
    >
      {/* Aerolínea */}
      <Grid item xs={12} sx={{ display: 'grid', justifyItems: 'center' }}>
        <Typography
          component="span"
          sx={{
            fontFamily: 'Open Sans',
            fontSize: '16px',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 600,
            color: '#000000',
            marginBottom: '6px',
            [theme.breakpoints.down('sm')]: {
              fontSize: '14px',
            },
          }}
        >
          <Box
            component="img"
            src={flights[0]?.logo || DefaultLogo}
            alt="aerolineas"
            sx={{
              height: { xs: '20px', sm: '30px' },
              marginRight: '1vw',
            }}
          />
          {flights[0]?.carrier_description}
        </Typography>
      </Grid>

      {/* Divider */}
      <Divider sx={{ width: 'calc(100% - 2.5rem)', margin: '3px auto' }} />

      {/* Datos de vuelos */}
      <Grid
        container
        spacing={0}
        sx={{
          display: 'grid',
          justifyItems: 'center',
          backgroundColor: '#FFFFFF',
          borderRadius: '8px',
        }}
      >
        {flights.map((flight, idx) => (
          <Grid
            key={`tooltip-three-days-${idx}`}
            container
            item
            xs={12}
            sx={{ padding: '0px' }}
          >
            <FlightsTooltipData flight={flight} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default TooltipData;
